import React from 'react';
import { MAX_DISPLAY_IMAGE_WIDTH } from '../../constants/game';
import { ImageDifficultySettings } from '../../types/difficulty';

interface StandardImageProps {
  imageUrl: string;
  filterCss: string;
  difficultySettings: ImageDifficultySettings;
  onLoad: (dimensions: { width: number; height: number }) => void;
}

const StandardImage: React.FC<StandardImageProps> = ({ imageUrl, filterCss, difficultySettings, onLoad }) => {
  const { isCropped, cropPercentage, isFlipped } = difficultySettings;
  const handleLoad = (e: React.SyntheticEvent<HTMLImageElement>) => {
    const img = e.currentTarget;
    onLoad({ width: img.naturalWidth, height: img.naturalHeight });
  };

  if (isCropped) {
    // Calculate the crop window size based on percentage
    // cropPercentage represents how much to remove from edges
    // e.g., 30% means remove 15% from each side, showing 70% of the image
    // 90% means remove 45% from each side, showing only 10% of the image
    const showPercentage = 100 - cropPercentage;
    const cropSize = (MAX_DISPLAY_IMAGE_WIDTH * showPercentage) / 100;
    
    // Combine translate (for centering) and scaleY (for flipping) transforms
    const combinedTransform = isFlipped 
      ? 'translate(-50%, -50%) scaleY(-1)' 
      : 'translate(-50%, -50%)';
    
    return (
      <div className="cropped-wrapper" style={{ width: cropSize, height: cropSize }}>
        <img
          src={imageUrl}
          alt="Guess the artist"
          style={{ 
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: combinedTransform,
            width: MAX_DISPLAY_IMAGE_WIDTH,
            height: 'auto',
            ...(filterCss ? { filter: filterCss } : {})
          }}
          onLoad={handleLoad}
        />
      </div>
    );
  }

  const transformStyle = isFlipped ? { transform: 'scaleY(-1)' as const } : {};

  const baseStyle: React.CSSProperties = { maxWidth: MAX_DISPLAY_IMAGE_WIDTH };
  const imageStyle = {
    ...baseStyle,
    ...(filterCss ? { filter: filterCss } : {}),
    ...transformStyle,
  };

  return <img src={imageUrl} alt="Guess the artist" style={imageStyle} onLoad={handleLoad} />;
};

export default StandardImage;

